import { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography } from '@mui/material';
import colors from '../../essentials/colors';
import styled from 'styled-components';
import AuthContext from '../../context/auth/authContext';
import ClientrdContext from '../../context/clientrd/clientrdContext';
import { useNavigate } from 'react-router-dom';
const TableSummary = styled(TableContainer)`
    background: ${colors.lightblue};
`;
const PaymentTableCell = styled(TableCell)`
    && {
        font-weight: 900;
        background: rgba(149, 213, 84);
        font-size: 18px;
    }
`;
const PaymentBodyTableCell = styled(TableCell)`
    && {
        font-weight: 300;
        // background: rgba(149, 213, 84, 0.5);
        font-size: 18px;
    }
`;

const NetIncome = styled(Paper)`
    && {
        border: 4px solid ${colors.purple};
        background-color: ${colors.purple};
        color: white;
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;
const AmountPaid = styled(Paper)`
    && {
        border: 4px solid ${colors.primary};
        color: white;
        background-color: ${colors.primary};
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;

const AmountPending = styled(Paper)`
    && {
        border: 4px solid ${colors.orange};
        color: ${colors.orange};
        border-radius: 10px;
        // box-shadow: 4px 5px 5px ${colors.grey};
    }
`;
const TotalClients = styled(Paper)`
    && {
        background: rgba(182, 88, 255, 0.4);
        background-color: ${colors.lightblue};
        // border: 4px solid ${colors.lightblue};
        color: white;
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;

const AllClients = () => {
    const authContext = useContext(AuthContext);
    const { user, isAuthenticated } = authContext;
    const clientrdContext = useContext(ClientrdContext);
    const { clientrds, getClientrds, updateClientrd } = clientrdContext;
    const [allclients, setAllClients] = useState([]);
    const [paymentcomplete, setPayment] = useState(0);
    const [amountdue, setAmountDue] = useState(0);
    const [paidclients, setPaidClients] = useState(0);

    let navigate = useNavigate();

    useEffect(() => {
        !isAuthenticated ? navigate('/login') : null;

        getClientrds();
        clientrds?.map((c) => {
            let d = 0;
            allclients?.map((a) => {
                c?.name === a?.name &&
                c?.email === a?.email &&
                c?.contact === a?.contact
                    ? (d += 1)
                    : null;
            });
            d === 0 ? allclients?.push(c) : null;
        });
    }, [allclients, allclients?.length, clientrds?.length]);

    return (
        <>
            <div style={{ marginBottom: 2 }}>
                Welcome! <b>{user && user.name}</b>
            </div>

            <br></br>
            <Typography variant="h4">All Clients List</Typography>
            <br></br>
            {allclients?.length == 0 || allclients?.length == undefined ? (
                <>
                    <Typography variant="h5" style={{ textAlign: 'center' }}>
                        <br></br>
                        No client record present.
                    </Typography>

                    <br></br>
                    <p style={{ textAlign: 'center' }}>
                        <button
                            onClick={() => navigate('/clientform')}
                            style={{
                                height: '60px',
                                width: '160px',
                                fontWeight: '300',
                                backgroundColor: `${colors.primary}`,
                                fontSize: '16px',
                                borderColor: 'transparent',
                                borderRadius: '10px'
                            }}
                        >
                            Add A Client
                        </button>
                    </p>
                </>
            ) : (
                <TableSummary component={Paper}>
                    <Table sx={{ minWidth: 200 }} size="small">
                        <TableHead>
                            <TableRow>
                                <PaymentTableCell>Name</PaymentTableCell>

                                <PaymentTableCell align="center">
                                    Phone No.
                                </PaymentTableCell>
                                <PaymentTableCell align="center">
                                    Email id
                                </PaymentTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allclients?.map((row) => (
                                <TableRow
                                    key={row.createdAt}
                                    sx={{
                                        '&:last-child td, &:last-child th': {
                                            border: 0
                                        }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <PaymentBodyTableCell
                                        scope="row"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.name}
                                        </p>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="right"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.contact}
                                        </p>
                                    </PaymentBodyTableCell>

                                    <PaymentBodyTableCell
                                        align="right"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.email}
                                        </p>
                                    </PaymentBodyTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableSummary>
            )}
        </>
    );
};
export default AllClients;
